const HeartButton = ({ liked, likedClick }) => {
  const handleClick = () => {
    if (likedClick) {
      likedClick(!liked);
    }
  };

  return (
    <div
      className="keduall-heart-button flex align-items-center justify-content-center cursor-pointer"
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        handleClick();
      }}
    >
      <i className={`icon pi pi-heart${liked ? "-fill" : ""}`}></i>
    </div>
  );
};

export default HeartButton;
